/**
 * Vue tableau de bord — règle simple à deux niveaux :
 * 1. Fonction d'encadrement (responsable de pôle) → vue pilotage correspondante.
 * 2. Sinon, catégorie du pôle métier → vue métier (commercial / designer / logistique).
 * 3. Sinon → vue entité.
 */

export const POLE_KEYS = /** @type {const} */ ([
    'entite',
    'commercial',
    'designer',
    'logistique',
    'encadrement_commercial',
    'encadrement_designer',
    'encadrement_logistique',
]);

/** @typedef {'entite'|'commercial'|'designer'|'logistique'|'encadrement_commercial'|'encadrement_designer'|'encadrement_logistique'} DashboardPole */

export const POLE_LABELS = {
    entite: 'Vue entité',
    commercial: 'Commercial',
    designer: 'Designer',
    logistique: 'Logistique',
    encadrement_commercial: 'Encadrement commercial',
    encadrement_designer: 'Encadrement designer',
    encadrement_logistique: 'Encadrement logistique',
};

/** Fonction officielle → vue tableau de bord encadrement.
 *  « direction » n'a pas de vue dédiée : elle voit la synthèse entité. */
export const FONCTION_ENCADREMENT_TO_POLE = {
    responsable_commercial: 'encadrement_commercial',
    responsable_designer: 'encadrement_designer',
    responsable_logistique: 'encadrement_logistique',
    direction: 'entite',
};

/** Catégorie du pôle métier (User.pole.categorie) → vue tableau de bord */
export const POLE_CATEGORIE_TO_DASHBOARD = {
    commercial: 'commercial',
    design: 'designer',
    logistique: 'logistique',
};

/** @param {unknown} pole */
export function isValidDashboardPole(pole) {
    return POLE_KEYS.includes(pole);
}

/**
 * Résout la vue tableau de bord : fonction d'encadrement, sinon pôle métier, sinon vue entité.
 * @param {{ fonctionEncadrement?: string, pole?: { categorie?: string }|null }} user
 * @returns {DashboardPole}
 */
export function resolveDashboardPoleFromUser(user) {
    const fromFonction = user?.fonctionEncadrement && FONCTION_ENCADREMENT_TO_POLE[user.fonctionEncadrement];
    if (fromFonction) return /** @type {DashboardPole} */ (fromFonction);

    const fromPole = user?.pole?.categorie && POLE_CATEGORIE_TO_DASHBOARD[user.pole.categorie];
    if (fromPole) return /** @type {DashboardPole} */ (fromPole);

    return 'entite';
}
